module.exports = __webpack_public_path__ + "static/img/img4.12233d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/img4.png
// module id = PXFb
// module chunks = 1